import { createContext } from 'react';
import { AnalyticsUserContextResponse } from '@src/@types/analytics-user';

type AnalyticsUserContextShape = {
  loaded: boolean;
  error: Error | null;
  analyticsUserContextResponse: AnalyticsUserContextResponse | null;
};
export const AnalyticsUserContext = createContext<AnalyticsUserContextShape>({
  loaded: false,
  error: null,
  analyticsUserContextResponse: null,
});
